import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import type { CandidateInterview } from '@/types/candidates';
import { CandidateInterviewScheduler } from './candidate-interview-scheduler';

interface CandidateInterviewDialogProps {
  candidateId: string;
  /** If set — dialog is in edit-mode; otherwise create-mode. */
  interview?: CandidateInterview | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function CandidateInterviewDialog({
  candidateId,
  interview,
  open,
  onOpenChange,
}: CandidateInterviewDialogProps) {
  const isEdit = !!interview;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[520px]">
        <DialogHeader>
          <DialogTitle>{isEdit ? 'Edit interview' : 'Schedule interview'}</DialogTitle>
          <DialogDescription>
            {isEdit
              ? 'Update time, meeting link or attendees. Vacancy link is fixed.'
              : 'Pick a time or a window. Attendees and the candidate will be emailed (calendar invite included for fixed times).'}
          </DialogDescription>
        </DialogHeader>
        {open ? (
          <CandidateInterviewScheduler
            candidateId={candidateId}
            interview={interview ?? null}
            embedded
            onDone={() => onOpenChange(false)}
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
